import request from "@/common/request"
import { Page } from "@/models/Page"
import { ItemDaPreVenda, ItemDaPreVendaImportacao } from "@/models/pre-venda/PreVenda"
import { AxiosRequestConfig } from "axios"

const basePath = '/item-pre-venda'

export const importarItens = (preVendaId: string, itensImportacao: ItemDaPreVendaImportacao[], tipoDePreVenda: string): Promise<void> => 
	request.post(`${basePath}/${preVendaId}/importar?tipoDePreVenda=${tipoDePreVenda}`, itensImportacao)

export const findItensDaPreVenda = (params?: any, config?: AxiosRequestConfig): Promise<Page<ItemDaPreVenda>> => 
	request.get(`${basePath}`, {
		params,
		...config,
	})

export const remover = (idItemPreVenda: string, preVendaId: string): Promise<void> => 
	request.post(`${basePath}/${idItemPreVenda}/${preVendaId}`)

export const salvarOuAtualizarItemPreVenda = (itemPreVendaForm: ItemDaPreVenda, preVendaId: string, tipoDePreVenda: string, atualizarPreco = false): Promise<boolean> =>
	request.post(`${basePath}/${preVendaId}/salvar-ou-atualizar?tipoDePreVenda=${tipoDePreVenda}&atualizarPreco=${atualizarPreco}`, itemPreVendaForm)

export const atualizarDescontoDoItem = (itemId: string, descontoIsPercentual: boolean, descontoValor: number): Promise<void> =>
	request.patch(`${basePath}/${itemId}/desconto`, null, {
		params: { descontoIsPercentual, descontoValor },
	})

export const atualizarPrecoDoItem = (itemId: string, preco: number): Promise<void> =>
	request.patch(`${basePath}/${itemId}/preco`, null, {
		params: { preco },
	})